import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { RoutePermissionsService } from '../core/services/route-permissions.service';

export const environmentPermissionGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const routePermissionService = inject(RoutePermissionsService);

  const urls = state.url.split('/');
  if (urls?.length < 1) {
    return redirectToAnotherPageIfRouteNotHasPermission(0);
  }

  if (routePermissionService.hasPermissionForRoute(urls[1])) {
    return true;
  }

  return redirectToAnotherPageIfRouteNotHasPermission();
}

const redirectToAnotherPageIfRouteNotHasPermission = (index: number = 0): boolean => {
  const routePermissionService = inject(RoutePermissionsService);
  const router = inject(Router);

  const route = routePermissionService.getRouteByIndex(index);

  if (route && route.permission) {
    void router.navigateByUrl(route.path);
    return true;
  } else {
    index = index + 1;
    return redirectToAnotherPageIfRouteNotHasPermission(index);
  }
}
